var navigation_list = [
	{
		id:1,
		title:'选择礼品',
		complete:true,
	},
	{
		id:2,
		title:'填写订单',
		complete:false,
	},
	{
		id:3,
		title:'评价晒图',
		complete:false,
	},
	{
		id:4,
		title:'填写地址',
		complete:false,
	}
]

export { navigation_list }